<div class="inicio">
  <form #insertForm="ngForm" [formGroup]="formDetSolicitud">

    <p class="titulo">SOLICITUD DE {{tipoSolicitud}} </p>
    <div class="grid-containerB">
      <button mat-mini-fab style="background-color: #00c030d0;  color: white;" (click)="goBack()"> <span
          class="material-icons">undo</span> </button>
    </div>
    <div class="grid-container2">
      <div class="celda">
        <mat-label class="label">Tipo de solicitud</mat-label>
        <mat-form-field appearance="outline">
          <input matInput type="text" placeholder="Tipo se solicitud" formControlName="tipoSolicitud" readonly />
        </mat-form-field>
      </div>

    </div>
    <!--DATOS DEL COLABORADOR-->
    <p></p>
    <h3>DATOS DEL COLABORADOR</h3>
    <div class="div">
      <!--Nombre del colaborador-->
      <div class="grid-container">
        <div class="celda">
          <mat-label class="label"> Nombre del colaborador </mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="Nombre del colaborador" formControlName="colaborador" readonly />
          </mat-form-field>
        </div>
      </div>
      <!--Cargo y sucursal/oficina-->
      <div class="grid-container2">
        <!--Cargo-->
        <div class="celda">
          <mat-label class="label"> Cargo </mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="No se encontró este campo" formControlName="puesto" readonly />
          </mat-form-field>
        </div>

        <!--Oficina/Sucursal-->
        <div class="celda">
          <mat-label class="label"> Sucursal </mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="No se encontró este campo" formControlName="sucursal" readonly />
          </mat-form-field>
        </div>
      </div>
    </div>
    <p></p>
    <div class="div">
      <!--Sustituye a-->
      <div class="grid-container">
        <mat-label class="label"> Sustituye a </mat-label>
        <mat-form-field appearance="outline">
          <input matInput type="text" placeholder="No se encontró este campo" formControlName="sustituye_a" readonly />
        </mat-form-field>
      </div>
      <!--supervisor-->
      <div class="grid-container">
        <mat-label class="label"> Nombre del supervisor </mat-label>
        <mat-form-field appearance="outline">
          <input matInput type="text" placeholder="Nombre del supervisor" formControlName="supervisor" readonly />
        </mat-form-field>
      </div>
    </div>
    <!--DATOS DEL SOLICITANTE-->
    <p></p>
    <h3>DATOS DEL SOLICITANTE</h3>
    <div class="div">
      <!--Nombre del colaborador-->
      <div class="grid-container">
        <div class="celda">
          <mat-label class="label"> Nombre del solicitante </mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="No se encontró este campo" formControlName="solicitante"
              readonly />
          </mat-form-field>
        </div>
      </div>
      <!--Cargo y sucursal/oficina-->
      <div class="grid-container2">
        <!--Cargo-->
        <div class="celda">
          <mat-label class="label"> Cargo </mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="No se encontró este campo" formControlName="puesto_solicitante"
              readonly />
          </mat-form-field>
        </div>

        <!--Oficina/Sucursal-->
        <div class="celda">
          <mat-label class="label"> Sucursal </mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="No se encontró este campo" formControlName="sucursal_solicitante"
              readonly />
          </mat-form-field>
        </div>
      </div>
      <!--email-->
      <div class="grid-container">
        <div class="celda">
          <mat-label class="label"> Email </mat-label>
          <mat-form-field appearance="outline">
            <input matInput type="text" placeholder="No se encontró este campo" formControlName="email_solicitante"
              readonly />
          </mat-form-field>
        </div>
      </div>
    </div>
    <!--DATOS GNERALES DE LOS PRIVILEGIOS-->
    <p></p>
    <h3>DATOS GENERALES</h3>
    <div class="div">



      <!--
      ##       ###    ##       ########    ###        ######  ######## ########  ##     ## ####  ######  ####  #######   ######  
      ##      ## ##   ##          ##      ## ##      ##    ## ##       ##     ## ##     ##  ##  ##    ##  ##  ##     ## ##    ## 
      ##     ##   ##  ##          ##     ##   ##     ##       ##       ##     ## ##     ##  ##  ##        ##  ##     ## ##       
      ##    ##     ## ##          ##    ##     ##     ######  ######   ########  ##     ##  ##  ##        ##  ##     ##  ######  
      ##    ######### ##          ##    #########          ## ##       ##   ##    ##   ##   ##  ##        ##  ##     ##       ## 
      ##    ##     ## ##          ##    ##     ##    ##    ## ##       ##    ##    ## ##    ##  ##    ##  ##  ##     ## ##    ## 
      ##    ##     ## ########    ##    ##     ##     ######  ######## ##     ##    ###    ####  ######  ####  #######   ######  
      -->

      <!--TABLAS DE SERVICIOS SOLICITADOS-->
      <div class="grid-container" *ngIf=" statusSolicitud=='Espera' && banderaExpediente !='true' ">
        <div class="grid-container2">
          <div class="celda">
            <mat-label class="label"> AGREGAR SERVICIOS </mat-label>
            <mat-form-field appearance="fill">
              <mat-label> Seleccione los servicios que requiera </mat-label>
              <mat-select formControlName="tipo_servicio" multiple>
                <mat-option *ngFor="let servicio of listaServicios"
                  [value]="servicio">{{servicio.nombre_servicio}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="celda" class="wrapper">
            <button type="submit" mat-raised-button color="primary"
              style="background-color: #00d836d0; width:350px; height:50px; color: white;"
              (click)="agregarServicioAlta()" [disabled]="cargando">
              Añadir servicios
            </button>
          </div>
        </div>

        <!--Servicio a solicitar alta de servicios-->

        <mat-label class="label"> SERVICIOS </mat-label>
        <div>
          <table mat-table [dataSource]="dataSource" class="wrapper" class="mat-elevation-z8">

            <ng-container matColumnDef="c1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
              <td mat-cell *matCellDef="let element"> {{element.nombre_servicio}} </td>
            </ng-container>
            <ng-container matColumnDef="c2">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field>
                  <mat-label>Ingrese el usuario</mat-label> <!--[ngModelOptions]="{standalone: true}"-->
                  <input matInput (keydown.space)="$event.preventDefault();" [(ngModel)]="element.usuario"
                    [ngModelOptions]="{standalone: true}" pattern="{{element.expresionRegular}}" [disabled]="cargando">
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="c3">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> PASSWORD </th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field>
                  <mat-label>Ingrese la contraseña</mat-label><!--[ngModelOptions]="{standalone: true}"-->
                  <input matInput (keydown.space)="$event.preventDefault();" [(ngModel)]="element.contrasenia"
                    [ngModelOptions]="{standalone: true}" [disabled]="cargando">
                </mat-form-field>
              </td>
            </ng-container>
            <!--Selección de las sucursales-->
            <ng-container matColumnDef="c4">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> SELECCIONE LA(S) SUCURSAL(ES) </th>
              <td mat-cell *matCellDef="let element">
                <mat-form-field appearance="fill">
                  <mat-label> Seleccione la o las sucursales </mat-label>
                  <mat-select [(ngModel)]="element.sucursales" [ngModelOptions]="{standalone: true}" multiple
                    [disabled]="cargando">
                    <mat-option *ngFor="let sucursal of listaSucursales"
                      [value]="sucursal">{{sucursal.nombreSucursal}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
            </ng-container>
            <!--Visualización de las sucursales seleccionadas-->
            <ng-container matColumnDef="c5">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> LISTA DE SUCURSALES </th>
              <td mat-cell *matCellDef="let element"> {{this.leerSucursales(element.sucursales)}}</td>
            </ng-container>
            <ng-container matColumnDef="c6">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> ACCIONES </th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button color="warn"
                  (click)="eliminarServicioDetalleSolicitud(element.detalle_solicitud_id)" [disabled]="cargando">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
            <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>
            <h2></h2>

          </table>
        </div>
        <p></p>
      </div> <!--CIERRE DE LAS TABLAS DE SERVICIOS SOLICITADOS-->









      <!--
        ##    ######## ########  ####  ######  ####  #######  ##    ##     ######  ########  ######## ########      
        ##    ##       ##     ##  ##  ##    ##  ##  ##     ## ###   ##    ##    ## ##     ## ##       ##     ##     
        ##    ##       ##     ##  ##  ##        ##  ##     ## ####  ##    ##       ##     ## ##       ##     ##     
              ######   ##     ##  ##  ##        ##  ##     ## ## ## ##    ##       ########  ######   ##     ##     
        ##    ##       ##     ##  ##  ##        ##  ##     ## ##  ####    ##       ##   ##   ##       ##     ##     
        ##    ##       ##     ##  ##  ##    ##  ##  ##     ## ##   ###    ##    ## ##    ##  ##       ##     ## ### 
        ##    ######## ########  ####  ######  ####  #######  ##    ##     ######  ##     ## ######## ########  ### 
      -->
      <div *ngIf="statusSolicitud === 'Atendido'">
        <button mat-raised-button color="primary" (click)="toggleEditar()" *ngIf="!editandoCredenciales"
          [disabled]="cargando">
          Editar credenciales
        </button>
      </div>

      <br><br>

      <div class="grid-container" *ngIf="statusSolicitud === 'Atendido' && editandoCredenciales">
        <div class="grid-container2">
          <div class="celda">
            <mat-label class="label"> AGREGAR SERVICIOS EDITANDO </mat-label>
            <mat-form-field appearance="fill">
              <mat-label> Seleccione los servicios que requiera </mat-label>
              <mat-select formControlName="tipo_servicio" multiple [disabled]="cargando">
                <mat-option *ngFor="let servicio of listaServicios" [value]="servicio">
                  {{servicio.nombre_servicio}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="celda" class="wrapper">
            <button type="submit" mat-raised-button color="primary" [disabled]="cargando"
              style="background-color: #00d836d0; width:350px; height:50px; color: white;"
              (click)="agregarNuevosServiciosEdicion()">Añadir servicios</button>
          </div>
        </div>

        <!--Servicio a solicitar alta de servicios-->

        <mat-label class="label"> SERVICIOS </mat-label>


        <table mat-table [dataSource]="dataSourceEdicion" class="wrapper" class="mat-elevation-z8">
          <ng-container matColumnDef="c1">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
            <td mat-cell *matCellDef="let element"> {{element.nombre_servicio}} </td>
          </ng-container>

          <ng-container matColumnDef="c2">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
            <td mat-cell *matCellDef="let element">
              <mat-form-field>
                <mat-label>Ingrese el usuario</mat-label> <!--[ngModelOptions]="{standalone: true}"-->
                <input matInput (keydown.space)="$event.preventDefault();" [(ngModel)]="element.usuario"
                  [ngModelOptions]="{standalone: true}" pattern="{{element.expresionRegular}}"
                  [disabled]="element.eliminar || cargando">
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="c3">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PASSWORD </th>
            <td mat-cell *matCellDef="let element">
              <mat-form-field>
                <mat-label>Ingrese la contraseña</mat-label><!--[ngModelOptions]="{standalone: true}"-->
                <input matInput (keydown.space)="$event.preventDefault();" [(ngModel)]="element.contrasenia"
                  [ngModelOptions]="{standalone: true}" [disabled]="element.eliminar || cargando">
              </mat-form-field>
            </td>
          </ng-container>

          <!--Selección de las sucursales-->
          <ng-container matColumnDef="c4">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> SELECCIONE LA(S) SUCURSAL(ES) </th>
            <td mat-cell *matCellDef="let element">
              <mat-form-field appearance="fill">
                <mat-label> Seleccione la o las sucursales </mat-label>
                <mat-select [(ngModel)]="element.sucursales" [ngModelOptions]="{standalone: true}" multiple
                  [disabled]="element.eliminar || cargando">
                  <mat-option *ngFor="let sucursal of listaSucursales"
                    [value]="sucursal">{{sucursal.nombreSucursal}}</mat-option>
                </mat-select>
              </mat-form-field>
            </td>
          </ng-container>

          <!--Visualización de las sucursales seleccionadas-->
          <ng-container matColumnDef="c5">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> LISTA DE SUCURSALES </th>
            <td mat-cell *matCellDef="let element">
              {{this.leerSucursales(element.sucursales)}}</td>
          </ng-container>

          <ng-container matColumnDef="c6">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ACCIONES </th>
            <td mat-cell *matCellDef="let element">
              <div style="display: flex; flex-direction: row; align-items: center;">
                <button mat-icon-button color="warn" [disabled]="cargando"
                  (click)="eliminarServicioDetalleSolicitudEditando(element)" *ngIf="!element.eliminar">
                  <mat-icon>delete</mat-icon>
                </button>
                <button mat-icon-button color="primary" [disabled]="cargando" (click)="revertirEliminacion(element)"
                  *ngIf="element.eliminar">
                  <mat-icon>refresh</mat-icon>
                </button>
                <p style="font-style: italic;" *ngIf="element.eliminar">eliminar</p>
              </div>
            </td>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
          <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>
          <h2></h2>

        </table>
        <div style="margin-top: 20px; gap: 10px; display: flex; flex-direction: row;">
          <button mat-raised-button color="primary" (click)="guardarEdicion()" *ngIf="editandoCredenciales"
            [disabled]="cargando">
            Guardar edición
          </button>

          <button mat-raised-button color="warn" (click)="cancelarEdicion()" *ngIf="editandoCredenciales"
            [disabled]="cargando">
            Cancelar edición
          </button>
        </div>

      </div>











      <!--DETALLE DE LOS SERVICIOS DE UNA SOLICITUD ATENDIDA  -->
      <div class="grid-tabla"
        *ngIf="(statusSolicitud === 'Atendido' || statusSolicitud === 'Cancelado' || banderaExpediente === 'true') && !editandoCredenciales">
        <mat-label class="label"> SERVICIOS </mat-label>
        <br>
        <!--Tabla-->
        <table mat-table [dataSource]="dataAtendidos" class="mat-elevation-z8">
          <ng-container matColumnDef="c1">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
            <td mat-cell *matCellDef="let element"> {{element.nombre_servicio}} </td>
          </ng-container>
          <ng-container matColumnDef="c2">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTATUS DEL SERVICIO </th>
            <td mat-cell *matCellDef="let element"> {{element.status_serv}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="encabezadostabAtendidos"></tr>
          <tr mat-row *matRowDef="let row; columns: encabezadostabAtendidos;"></tr>
        </table>
      </div>











      <br> <br> <br>
      <!--TABLA DE SERVICIOS DADOS DE ALTA SOLICITUD ANTENDIDA-->
      <div class="grid-tabla" style="margin-bottom: 25px;" *ngIf="statusSolicitud=='Atendido' && !editandoCredenciales">
        <mat-label class="grid-container" class="label">
          SERVICIOS ACTIVADOS DE ESTA SOLICITUD
          <mat-spinner *ngIf="cargandoActualizacion" diameter="30"></mat-spinner>
        </mat-label>
        <p></p>
        <table mat-table [dataSource]="dataSourceServiciosSucursalesAlta" class="mat- elevation-z8">

          <ng-container matColumnDef="c1">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
            <td mat-cell *matCellDef="let element"> {{element.detalleSolicitud.tipo_servicio.nombre_servicio}} </td>
          </ng-container>
          <ng-container matColumnDef="c2">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
            <td mat-cell *matCellDef="let element; let i=index">
              {{element.usuario}}
            </td>
          </ng-container>
          <ng-container matColumnDef="c3">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PASSWORD </th>
            <td mat-cell *matCellDef="let element; let i=index">
              {{element.contrasenia}}
            </td>
          </ng-container>
          <ng-container matColumnDef="c4">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> SUCURSAL </th>
            <td mat-cell *matCellDef="let element"> {{element.nomSucursalCol}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="encabezadostabla4"></tr>
          <tr mat-row *matRowDef="let row; columns: encabezadostabla4;"></tr>
          <h2></h2>
        </table>
        <br>
      </div>







      <!--Fecha de asignación-->
      <div class="celda">
        <mat-label class="label">Fecha de asignación</mat-label>
        <mat-form-field appearance="outline">
          <input matInput type="text" placeholder="No se encontró este campo" formControlName="fecha_planeada"
            readonly />
        </mat-form-field>
      </div>
      <P></P>
      <!--Comentarios-->
      <div class="grid-container">
        <div class="celda">
          <mat-label class="label">Comentarios</mat-label>
          <mat-form-field class="example-full-width" appearance="outline">
            <textarea matInput placeholder="Comentarios" formControlName="comentarios" readonly></textarea>
          </mat-form-field>
        </div>
      </div>



    </div>
    <p></p>
    <!--Botones-->
    <div class="grid-container2" *ngIf="statusSolicitud=='Espera' && banderaExpediente !== 'true' ">
      <!--Boton guaradar-->
      <button type="submit" mat-raised-button color="primary" (click)="agregarServicio()" [disabled]="cargando">
        Aceptar
      </button>
      <!--Boton cancelar-->
      <button mat-raised-button color="warn" (click)="rechazarSolicitud()" [disabled]="cargando">
        Rechazar solicitud <mat-icon>cancel</mat-icon>
      </button>
    </div>
    <div class="wrapper"
      *ngIf="statusSolicitud === 'Atendido' || statusSolicitud === 'Cancelado' || banderaExpediente === 'true' ">
      <button mat-raised-button style="background-color: #00c030d0; width:350px; color: white;" (click)="goBack()"
        [disabled]="cargando">
        Aceptar<mat-icon>done_all</mat-icon>
      </button>
    </div>

  </form>
</div>